import { useState, useEffect } from 'react'
import { TransparentCardMobile } from './TransparentCardMobile'
import { section4Data } from './data/section4Data'

export const Section4Mobile = () => {
  const [selectedPillar, setSelectedPillar] = useState(section4Data[0])
  const [remainingPillars, setRemainingPillars] = useState(
    section4Data.slice(1),
  )
  const [isAnimating, setIsAnimating] = useState(false) // Track animation state

  const handlePillarClick = (clickedPillarIndex: number) => {
    // Trigger animation
    setIsAnimating(true)

    const clickedPillar = remainingPillars[clickedPillarIndex]

    // Update the state: swap the selected pillar with the clicked one
    setRemainingPillars((prevPillars) => {
      const updatedPillars = [...prevPillars]
      updatedPillars[clickedPillarIndex] = selectedPillar
      return updatedPillars
    })

    setSelectedPillar(clickedPillar)
  }

  // Reset card animation state after the animation duration
  useEffect(() => {
    if (isAnimating) {
      const timeout = setTimeout(() => setIsAnimating(false), 150) // Must match animation duration
      return () => clearTimeout(timeout)
    }
  }, [isAnimating])
  return (
    <div className='flex flex-col justify-around !px-5 !py-20'>
      <div>
        <h3 className='text-center text-[#EBF3FF] text-lg font-bold leading-6 tracking-[0.4px] mb-6'>
          Our pillars of progress
        </h3>
        <p className='text-center text-[#EBF3FF] text-sm font-normal leading-4 tracking-[0.4px]'>
          We have achieved significant progress through our technology,
          leadership, customers and global presence in LawTech since 2017.
        </p>
        <div className='py-15'>
          <TransparentCardMobile
            key={selectedPillar.title} // Forces re-render when the selected pillar changes (so we see the animation)
            title={selectedPillar.title}
            body={selectedPillar.body}
            className={`transition-opacity duration-150 ease-in-out ${isAnimating ? 'opacity-0' : 'opacity-100'
              }`}
          />
        </div>
        <div className='flex gap-4 justify-center'>
          {remainingPillars.map((pillar, index) => (
            <button
              key={index}
              onClick={() => handlePillarClick(index)}
              className='px-4 py-2 w-25 h-20 text-sm font-medium text-[#EBF3FF] rounded-xl border border-[#818285] bg-[linear-gradient(180deg,_rgba(255,255,255,0.3)_0%,_rgba(0,0,0,0.30)_20%)] 
                shadow-[0px_8px_8px_0px_rgba(0,0,0,0.50)] cursor-pointer'
              title={pillar.title}
            >
              {pillar.title}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}
